import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UpdateUserStatusResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function updateUserStatusAction(uuid: string, status: string): Promise<ApiResponse<UpdateUserStatusResponse>> {
  return api.put<ApiResponse<UpdateUserStatusResponse>>(`/users/${uuid}/update-user-status`, { status })
}
